import { useCallback, useReducer } from 'react'

import { FORM_FIELD_NAME } from '@/constants/contactUs'
import {
  validateEmail,
  validateMessage,
  validateName,
  validatePhoneNumber,
  validateSelectQuery,
} from '@/util/validation'

interface ErrorState {
  name: string | null
  email: string | null
  phoneNumber: string | null
  message: string | null
  enquiryType: string | null
}

interface Payload {
  key: string
  message: string | null
}

const initialErrorState: ErrorState = {
  name: null,
  email: null,
  phoneNumber: null,
  message: null,
  enquiryType: null,
}

const errorStateReducer = (state: ErrorState, { key, message }: Payload) => {
  switch (key) {
    case FORM_FIELD_NAME.NAME: {
      return { ...state, name: message }
    }
    case FORM_FIELD_NAME.EMAIL: {
      return { ...state, email: message }
    }
    case FORM_FIELD_NAME.PHONE_NUMBER: {
      return { ...state, phoneNumber: message }
    }
    case FORM_FIELD_NAME.MESSAGE: {
      return { ...state, message }
    }
    default: {
      return { ...state, enquiryType: message }
    }
  }
}

const useContactUsForm = () => {
  const [errors, dispatch] = useReducer(errorStateReducer, initialErrorState)

  const validateFormItem = useCallback((key: string, value: string) => {
    let isFormValid = true
    let message: string | null = null
    if (key === FORM_FIELD_NAME.NAME) {
      message = validateName(value)
    } else if (key === FORM_FIELD_NAME.EMAIL) {
      message = validateEmail(value)
    } else if (key === FORM_FIELD_NAME.PHONE_NUMBER) {
      message = validatePhoneNumber(value)
    } else if (key === FORM_FIELD_NAME.MESSAGE) {
      message = validateMessage(value)
    } else if (key === FORM_FIELD_NAME.ENQUIRY_TYPE) {
      message = validateSelectQuery(value)
    }
    const validKeys = [
      FORM_FIELD_NAME.EMAIL,
      FORM_FIELD_NAME.NAME,
      FORM_FIELD_NAME.PHONE_NUMBER,
      FORM_FIELD_NAME.MESSAGE,
      FORM_FIELD_NAME.ENQUIRY_TYPE,
    ] as string[]

    if (validKeys.indexOf(key) !== -1) {
      if (message != null) {
        isFormValid = false
      }
    }
    dispatch({ key, message })
    return isFormValid
  }, [])

  return { errors, validateFormItem }
}

export default useContactUsForm
